export default "__VITE_ASSET__AoOhBg89__"